// This file was automatically generated from print.patientInstructions.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.patientInstructions');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.visitNote');
goog.require('el8.template.print.visitNote.twoCol');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientInstructions.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="rxUncontrolledContainer">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: 'Instructions', noInsurance: true}), output);
  output.append('<div class="orderContainer">');
  if (opt_data.note.instrBullets.length > 0) {
    output.append('<div class="ptInstructionWrap"><div class="rxInstrText"><div class="sectionText">');
    el8.template.print.visitNote.twoCol.numberedList({items: opt_data.note.instrBullets}, output);
    output.append('</div></div></div>');
  } else {
    output.append('<div class="ptInstructionWrap"><div class="rxInstrText"><div class="sectionText">No instructions provided.</div></div></div>');
  }
  output.append('</div>');
  if (opt_data.note.signDate) {
    el8.template.print.signature({localFsPath: opt_data.localFsPath, signPhysicianName: opt_data.note.prescribingPhysicianName, signDate: opt_data.note.signDate}, output);
  } else {
    output.append('<div class="signatureContainer"><p><span class="elt">By:</span><span class="emphasis elt">', soy.$$escapeHtml(opt_data.note.prescribingPhysicianName), '</span><span class="elt">on ', (soy.$$escapeHtml(opt_data.now)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.now)) : ''), '</span></p></div>');
  }
  el8.template.print.visitNote.signLog({note: opt_data.note}, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};
